import { render, staticRenderFns } from "./AlignmentEditorLayout.vue?vue&type=template&id=918e04d8"
import script from "./AlignmentEditorLayout.vue?vue&type=script&lang=js"
export * from "./AlignmentEditorLayout.vue?vue&type=script&lang=js"
import style0 from "./AlignmentEditorLayout.vue?vue&type=style&index=0&id=918e04d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports